import AddressDisplay from "~/components/address/AddressDisplay.tsx";
import Card from "~/components/Card/Card";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";

type Props = { invoice: Invoice; onUpdateClick?: () => void; };

const InvoiceAddressSection = ({ invoice, onUpdateClick }: Props) => {
	const addressIsSet = invoice.address !== null && invoice.recipientLegalName !== null;
	return <Card title="Rechnungsadresse & Empfänger E-Mail"
				 headerButtonText="Bearbeiten"
				 onHeaderButtonClick={onUpdateClick}>
		{invoice.address !== null && invoice.recipientLegalName !== null && <AddressDisplay address={invoice.address}
																							name={invoice.recipientLegalName} />}
		{!addressIsSet && <div className="text-sm text-gray-500">Keine Rechnungsadresse hinterlegt.</div>}
		<div className="h-4"/>
		{invoice.buyerEAddress && <div>{invoice.buyerEAddress}</div>}
		{!invoice.buyerEAddress && <div className="text-sm text-gray-500">Keine E-Mail für E-Rechnung hinterlegt.</div>}
	</Card>;
};

export default InvoiceAddressSection;